// Exports
export default {
	"videoContainMode": "videoContainMode_MM8PP"
};
